<template>
  <ul class="orderInfo">
    <li>
      <div class="th">分销员</div>
      <div class="td">{{ orderDeatilsData.distributorInfo ? orderDeatilsData.distributorInfo.name : '--' }}</div>
    </li>
    <li>
      <div class="th">上级分销员</div>
      <div class="td">{{ orderDeatilsData.distributionSuperiorInfo ? orderDeatilsData.distributionSuperiorInfo.name : '--' }}</div>
    </li>
    <li>
      <div class="th">分销员佣金</div>
      <div class="td">￥{{ orderDeatilsData.distributorInfo ? orderDeatilsData.distributorInfo.distributorCommission : '0.00' }}</div>
    </li>
    <li>
      <div class="th">上级分销员佣金</div>
      <div class="td">￥{{ orderDeatilsData.distributionSuperiorInfo ? orderDeatilsData.distributionSuperiorInfo.distributorCommission : '0.00' }}</div>
    </li>
  </ul>
</template>

<script>

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
    };
  },
  activated() {},
  methods: {}
};
</script>
<style lang="less" scoped>
</style>
